import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	back: {
		id: 'project-create-importer-upload-flow.common.step-footer.back',
		defaultMessage: 'Back',
		description: 'Button text to go to the previous step of the import',
	},
	next: {
		id: 'project-create-importer-upload-flow.common.step-footer.next',
		defaultMessage: 'Next',
		description: 'Button text to go to the next step of the import',
	},
	import: {
		id: 'project-create-importer-upload-flow.common.step-footer.import',
		defaultMessage: 'Import',
		description: 'Button text to start import',
	},
});
